import { memo } from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { MapLocation } from '@atom/types/map';
import { getWorkOrderStatusColor } from '@atom/utilities/workOrderStatusUtilities';

import { getGoogleShapeCenter } from '../mapUtilities';

import LineStringMarker from './LineStringMarker';
import { getWorkOrderSvg } from './markerIconUtilities';
import {
  lineStringPath,
  MARKER_STYLE,
  resolveAnchor,
  resolveZIndex,
} from './markerUtilities';

type TaskLocationMarkerProps = {
  location: MapLocation;
};

const TaskLocationMarker = ({ location }: TaskLocationMarkerProps) => {
  const isActive = location.isActive === true;
  const position = getGoogleShapeCenter(location.geometry);
  const path = lineStringPath(location.geometry);
  const svgUrl = getWorkOrderSvg(location.statusId, isActive);

  return (
    <>
      <AdvancedMarker
        position={position}
        zIndex={resolveZIndex('workOrder', isActive)}
        {...resolveAnchor('workOrder', isActive)}
        style={MARKER_STYLE}
      >
        <img src={svgUrl} alt="" />
      </AdvancedMarker>
      {path && (
        <LineStringMarker
          path={path}
          color={getWorkOrderStatusColor(location.statusId)}
          isActive={isActive}
          onClick={() => {}}
        />
      )}
    </>
  );
};

export default memo(TaskLocationMarker);
